import * as React from "react";
import * as _ from "underscore";

require("../../assets/stylesheets/components/underwriter_dashboard/hurdle_status.scss");

const classnames = require("classnames");

export const HURDLE_STATUSES = {
  GREEN: "green",
  RED: "red",
  YELLOW: "yellow",
};

// TODO: make component editable, which would render a select box

interface HurdleStatusProps {
  status: string;
  className?: string;
  // editable?: boolean;
  // onChange?: Function;
}

export class HurdleStatus extends React.Component<HurdleStatusProps, any> {
  statusToClasses(status: string): string {
    if (!_.contains(HURDLE_STATUSES, status)) {
      return "fa fa-question-circle hurdle-status__status";
    }

    return classnames({
      "fa fa-circle": true,
      "hurdle-status__status": true,
      "hurdle-status__status--green": status === HURDLE_STATUSES.GREEN,
      "hurdle-status__status--red": status === HURDLE_STATUSES.RED,
      "hurdle-status__status--yellow": status === HURDLE_STATUSES.YELLOW,
    });
  }

  render() {
    const { className, status } = this.props;

    const classes = classnames({
      "hurdle-status": true,
      [className]: !!className,
    });

    return (
      <div className={classes}>
        <i className={this.statusToClasses(status)} />
      </div>
    );
  }
}
